module.exports = __webpack_public_path__ + "img/banner-1.4ef0a5d5.jpg";